import Cisco from "public/cyberSecTechStack/cisco.png";
import Fortinet from "public/cyberSecTechStack/fortinet.png";
import PaloAlto from "public/cyberSecTechStack/paloalto.png";
import Versa from "public/cyberSecTechStack/versaLogo.png";
import Radware from "public/cyberSecTechStack/radware.png";
import Sophos from "public/cyberSecTechStack/sophos.png";
import CheckPoint from "public/cyberSecTechStack/check-point-logo.png";

export const CYBER_SEC_TECH_STACK_CONSTANTS = {
  title: "Our Security Stack",
  list: [
    { name: "Cisco", logo: Cisco },
    { name: "PaloAlto", logo: PaloAlto },
    { name: "Fortinet", logo: Fortinet },
    { name: "Sophos", logo: Sophos },
    { name: "Radware", logo: Radware },
    { name: "CheckPoint", logo: CheckPoint },
    { name: "Versa", logo: Versa },
  ],
};
